import { AlarmID } from '../../shared/models/id/alarm-id'
import {
  useAddCommentMutation,
  useGetAlarmCommentsQuery,
} from '../../store/kopiliot-api/alarm'
import AlarmCommentDisplay from './AlarmCommentDisplay'
import { useForm } from 'react-hook-form'
import { PostAlarmComment } from '../../shared/models/alarm.model'
import { Button, Form } from 'react-bootstrap'
import Input from '../../components/form/Input'
import Divider from '../../components/common/Divider'
import React from 'react'
import { SortOrderDirection } from '../../store/kopiliot-api/query-type'

interface Props {
  alarmID: AlarmID
}

const AlarmCommentList = ({ alarmID }: Props) => {
  const { data, isLoading, isFetching, error } = useGetAlarmCommentsQuery({
    alarmID,
    sortOrder: {
      direction: SortOrderDirection.DESC,
      property: 'createdAt',
    },
  })

  const form = useForm<PostAlarmComment>({
    defaultValues: { text: '', alarmID },
  })
  React.useEffect(() => {
    form.reset({ text: '', alarmID })
  }, [alarmID])
  const [postComment, { isLoading: isLoadingPostComment }] =
    useAddCommentMutation()
  const { handleSubmit, register } = form
  const onSubmit = async (data: PostAlarmComment) => {
    try {
      console.log(data)
      await postComment(data).unwrap()
      form.reset()
    } catch (e) {
      console.error(e)
    }
  }
  if (error) {
    return <div>Error: </div>
  }
  if (isFetching || isLoading) {
    return <div>Loading...</div>
  }
  return (
    <div>
      <Form {...form} onSubmit={handleSubmit(onSubmit)}>
        <Input
          register={register('text', { required: true })}
          type={'textarea'}
          error={form.formState.errors.text}
        />
        <div className={'mt-3 d-flex justify-content-end'}>
          <Button
            variant={'outline-primary'}
            type={'submit'}
            disabled={isLoadingPostComment}
          >
            Enregistrer
          </Button>
        </div>
      </Form>
      <Divider />
      {data?.map((comment) => (
        <div key={comment.id?.id}>
          <AlarmCommentDisplay comment={comment} />
        </div>
      ))}
    </div>
  )
}

export default AlarmCommentList
